<template lang="pug">
v-container#plan-view(fluid)
  v-card(flat)
    v-card-text
      .d-flex
        v-spacer
        //- Botón contextual: en la pestaña "Ventas" crea plan de ventas;
        //- en "Costos y Producción" ofrece esos dos.
        v-btn(v-if="tab === 0" color="primary" to="/nuevo-plan/ventas") Nuevo plan de ventas
        v-menu(v-else offset-y bottom left)
          template(v-slot:activator="{ on, attrs }")
            v-btn(color="primary" v-bind="attrs" v-on="on") Nuevo plan
          v-list
            v-list-item(to="/nuevo-plan/costos")
              v-list-item-title Crear Plan de Costos
            v-list-item(to="/nuevo-plan/produccion")
              v-list-item-title Crear Plan de Producción
    v-tabs.ml-4(v-model="tab" color="primary")
      v-tab Ventas
      v-tab Costos y Producción
    v-tabs-items(v-model="tab")
      v-tab-item
        v-card
          v-card-text
            v-alert(dense text color="primary" border="left" class="mb-4")
              | El <b>Plan Alcanzable (SOM)</b> que defines dentro de cada caso es tu meta anual. Aquí la
              |  bajas a <b>metas mensuales</b> y luego controlas su avance en Seguimiento.
            ListPlan
      v-tab-item
        v-card
          v-card-text
            ListCostAndProductionPlan
</template>

<script>
import ListPlan from '../components/plan/ListPlan.vue'
import ListCostAndProductionPlan from '../components/plan/ListCostAndProductionPlan.vue'

export default {
  components: {
    ListPlan,
    ListCostAndProductionPlan
  },
  data () {
    return {
      tab: parseInt(this.$route.query.tab) || 0
    }
  },
  watch: {
    '$route.query.tab' (val) {
      this.tab = parseInt(val) || 0
    }
  }
}
</script>